// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.App main {
  flex: 1 1;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--light-gray);
}

::-webkit-scrollbar-thumb {
  background: var(--primary-blue);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--secondary-blue);
}

/* Utility Classes */
.container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  padding: 0 20px;
}

.section-padding {
  padding: var(--section-padding);
}

.text-center {
  text-align: center;
}

.text-white {
  color: var(--white);
}

.text-primary {
  color: var(--primary-blue);
}

.text-gray {
  color: var(--text-gray);
}

.font-bold {
  font-weight: 700;
}

.font-semibold {
  font-weight: 600;
}

.font-medium {
  font-weight: 500;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-medium);
}

.btn-primary {
  background-color: var(--primary-blue);
  color: var(--white);
}

.btn-primary:hover {
  background-color: var(--secondary-blue);
  transform: translateY(-2px);
}

.btn-white {
  background-color: var(--white);
  color: var(--primary-blue);
}

.btn-white:hover {
  background-color: var(--light-gray);
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  color: var(--primary-blue);
  border: 2px solid var(--primary-blue);
}

.btn-outline:hover {
  background-color: var(--primary-blue);
  color: var(--white);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB","sourcesContent":[".App {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.App main {\n  flex: 1;\n}\n\n/* Scrollbar Styling */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--light-gray);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--primary-blue);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--secondary-blue);\n}\n\n/* Utility Classes */\n.container {\n  max-width: var(--container-max-width);\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.section-padding {\n  padding: var(--section-padding);\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-white {\n  color: var(--white);\n}\n\n.text-primary {\n  color: var(--primary-blue);\n}\n\n.text-gray {\n  color: var(--text-gray);\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--border-radius-sm);\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-medium);\n}\n\n.btn-primary {\n  background-color: var(--primary-blue);\n  color: var(--white);\n}\n\n.btn-primary:hover {\n  background-color: var(--secondary-blue);\n  transform: translateY(-2px);\n}\n\n.btn-white {\n  background-color: var(--white);\n  color: var(--primary-blue);\n}\n\n.btn-white:hover {\n  background-color: var(--light-gray);\n  transform: translateY(-2px);\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--primary-blue);\n  border: 2px solid var(--primary-blue);\n}\n\n.btn-outline:hover {\n  background-color: var(--primary-blue);\n  color: var(--white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
